module.exports = "//cdn.mxpnl.com/static/asset-cache/80fab6bbf96045eafc590869531fcf7b/iron/common/assets/images/charts/logarithmic-stacked-bar.svg";